import HintPopover from "../../../../gd-ui/hint-popover/hint-popover";
import React from "react";

type Props = {
    help?   : string
}

export default function SettingsHelp(props:Props) {

    return (
        <div className="settings-help">?

            <HintPopover hint={props.help} multiline={true} />

        </div>
    )



}